import Glide from 'glidejs';
import { throttle } from 'throttle-debounce';
import productGliderCustom from './productGliderCustom';

let MOBILE_GLIDE_BREAKPOINT = 749;

/**
 * Custom logic for specific glide instances
 */
const customGlideActions = {
  'product-image-slider': productGliderCustom
  // 'example-glide-id': customFunction,
};

/**
 * Standard Glide instantiation
 */
export const glidify = (container = document) => {
  const glides = container.querySelectorAll('[data-glide]');
  if (!glides.length) return;

  glides.forEach(glide => {
    const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
    const glideInstance = new Glide(glide, config).mount();
    const id = glide.dataset.glideId ? glide.dataset.glideId : null;
    if (customGlideActions[id]) {
      customGlideActions[id](glideInstance);
    }

    glideInstance.go('=0');
  });
};

/**
 * Instantiate glides for mobile only
 */
export const glidifyMob = (container = document) => {
  const glides = container.querySelectorAll('[data-glide-mob]');
  if (!glides.length) return;
  window.blubolt.glides = []; //reset glides
  const initGlideOnMobile = () => {
    // TODO: Swap less than
    glides.forEach(glide => {
      // console.log(glide.dataset, 'dataset')
      if (glide.dataset.glideBreakpoint) {
        return (MOBILE_GLIDE_BREAKPOINT = glide.dataset.glideBreakpoint);
      } else {
        return (MOBILE_GLIDE_BREAKPOINT = 749);
      }
    });

    if (window.innerWidth >= MOBILE_GLIDE_BREAKPOINT) {
      if (window.blubolt.glides) {
        const keys = Object.keys(window.blubolt.glides);
        keys.forEach(key => window.blubolt.glides[key].destroy());
        window.blubolt.glides = [];
      }
    } else {
      glides.forEach(glide => {
        const config = glide.dataset.gliderConfig ? JSON.parse(glide.dataset.gliderConfig) : {};
        const id = glide.dataset.glideId ? glide.dataset.glideId : null;

        if (id) {
          // Only create glide if it hasn't been created yet.
          if (!window.blubolt.glides[id]) {
            const glideInstance = new Glide(glide, config).mount();

            if (customGlideActions[id]) {
              customGlideActions[id](glideInstance);
            }
            window.blubolt.glides[id] = glideInstance;
          }
        } else {
          console.info('Please add data-glide-id to the slide');
        }
      });
    }
  };

  initGlideOnMobile();
  window.addEventListener(
    'resize',
    throttle(500, false, () => initGlideOnMobile())
  );
};

export default glidify;
